import type React from 'react';
import { createContext, useContext } from 'react';

interface DraggableListContextProps {
  onDrag?: (ev: Event, info: any) => void;
  onDragStart?: (dragControls?: any) => void;
  onDragEnd?: () => void;
}

const DraggableListContext = createContext<DraggableListContextProps>({});

export const DraggableListProvider: React.FC<{
  children: React.ReactNode;
  value: DraggableListContextProps;
}> = ({ children, value }) => <DraggableListContext.Provider value={value}>{children}</DraggableListContext.Provider>;

export const useDraggableListContext = () => {
  return useContext(DraggableListContext);
};
